<form [formGroup]="formGroupGenerate" (ngSubmit)="generate()">
  <mat-form-field appearance="fill">
    <mat-label>{{'BINARIES.APPLIANCE_GROUP' | translate}}</mat-label>
    <mat-select formControlName="applianceGroup" [disabled]="!eligibleApplianceGroups || eligibleApplianceGroups.length <= 1">
      <mat-option *ngFor="let applianceGroup of eligibleApplianceGroups | sortBy : 'label'" [value]="applianceGroup.key">{{applianceGroup.label}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>{{'BINARIES.TYPE' | translate}}</mat-label>
    <mat-select formControlName="type">
      <mat-option *ngFor="let type of types" [value]="type.key">{{type.label}}</mat-option>
    </mat-select>
  </mat-form-field>
  <p *ngIf="shouldDisableGeneration()" class="space-v-s space-h-s">{{generateFormErrorMessage|translate}}</p>
  <div class="form-buttons">
    <button mat-raised-button mat-dialog-close="" class="btn btn-warn space-h-s">{{'CANCEL' | translate}}</button>
    <button mat-raised-button type="submit" class="btn btn-submit space-h-s" [disabled]="shouldDisableGeneration()">
      {{'BINARIES.GENERATE' | translate}}
    </button>
  </div>
</form>
